module.exports = __webpack_public_path__ + "static/mtb-7-36bec08ef83a0230c3fb5dceb06728a2.jpg";